/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Polyfill pour react-snap (Chromium ancien ne supporte pas Object.hasOwn)
if (!Object.hasOwn) {
  Object.hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
}

import React from "react";
import * as ReactDOMClient from "react-dom/client";
import App from "App";
import { BrowserRouter } from "react-router-dom";
import { ThemeContextProvider } from "context/ThemeContext";

const container = document.getElementById("root");

const jsx = (
  <ThemeContextProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeContextProvider>
);

if (container.hasChildNodes()) {
  // Page pré-rendue par react-snap — on hydrate sans re-render
  ReactDOMClient.hydrateRoot(container, jsx);
} else {
  ReactDOMClient.createRoot(container).render(jsx);
}
